function config(){
	//var apiUrl = window.location.protocol+'//'+window.location.host+'/api';
	//var url = 'http://192.168.99.114:8989/admin';
	var apiUrl = 'https://api.zsmy.fyakm.com';
	var url = apiUrl+'/admin';
	return {
		webname:'掌尚名医管理系统',
		url:url,
		uploadUrl:apiUrl,
		key:'a1458bcfda668255', //加密秘钥
		iv:'b123456789ABCDEF',   //偏移量
	}
}
function doMain(){return this.config().url;}
function login(){return this.doMain() + '/admins/login';}
function register(){return this.doMain() + '/admins/register';}
function edit_oneself(){return this.doMain() + '/admins/edit_oneself';}
function upload(){return this.doMain() + '/upload/add';}
export default{
	doMain,
	login,
	register,
	edit_oneself,
	upload,
	config,
}